import { Component, OnInit, OnDestroy, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Observable, Subject, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { TaskService } from 'src/app/services/task.service';
import { AlertComponent } from '../../alert/alert.component';
import { ProcessMasterService } from 'src/app/services/process-master.service';
declare var $: any;
import * as _ from 'lodash';
import { SharerService } from 'src/app/services/sharer.service';
import { companyTask } from '../companyTask';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
import { ChangeDetectorRef } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-company-task-list',
  templateUrl: './company-task-list.component.html',
  styleUrls: ['./company-task-list.component.css']
})
export class CompanytasklistComponent implements OnInit, OnDestroy {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  
  dtOptionsforPeriodicTask: DataTables.Settings = {};
  dtTriggerforPeriodicTask: Subject<any> = new Subject();
  dtElementforEventBasedTask: DataTableDirective;

  checkAllPeriodicTask: any;

  dtOptionsEventBasedTask: DataTables.Settings = {};
  dtTriggerEventBasedTask: Subject<any> = new Subject();
  dtTrigger: Subject<any> = new Subject();
  dtDetailsHistory: DataTables.Settings = {};
  dtDetailsTrigger: Subject<any> = new Subject();
  // @ViewChild(DataTableDirective)
  // dtElement: DataTableDirective;
  // dtOptions: any = {};
  // The trigger needed to re-render the table
  // dtTrigger: Subject<any> = new Subject();
  activateTasksForm: FormGroup;
  taskConfigurationForm: FormGroup;
  groupTypes: any[];
  companytasklist: any[];
  //selectedCompanytasks: any[];
  selectedAllEventTask: any;
  selectedAllPeriodicTask: any;
  meetingTypes: any[];
  meetingtypeId: string;
  meetingType: string;
  IsSelectedTasks: any;
  groupID: any;
  taskID: any;
  processes: any[];
  approveBtnType: any;
  processType: string;
  // SearchtaskEventbasedorPeriodicModel: any;
  // SearchtaskUserdefinedorPredefinedModel: any;
  SearchtaskUserdefinedorPredefinedModelEventTask: any;
  SearchtaskUserdefinedorPredefinedModelPeriodicTask: any;
  taskStatus: any;
  isInactiveTask: any;
  countOfSelectedtask: any;
  countOfDeSelectedtask: any;
  groupname: any = null;
  selcettaskname: any = null;
  erroMessage: boolean = false;

  selectedCompanytasks: companyTask[] = [];
  hasPermission: any;
  currentURL: any;
  searcheFilteredDataEventTask: any[];
  searcheFilteredDataPeriodicTask: any[];
  newselectflag: any;
  togglecount: any;
  searchvalue: any;
  response: boolean;
  searchParamEvent: any = {};
  searchParam: any = {};
  triggerTypeofEventBased: any;
  triggerTypeofPeriodicBased: any;
  libraryEventBasedTaskList: any[] = [];
  libraryPeriodicBasedTaskList: any[] = [];
  UserListData: any[];
  private cachedUsersList$: Observable<any> | null = null;
  count: number = 0;
  isLoading: boolean = false;
  isSearchLoadingEvent: boolean = false;
  isSearchLoadingPeriodic: boolean = false;


  periodicTaskList: any[];

  // Bulk Upload Properties
  selectedBulkFile: File | null = null;
  bulkUploadPreviewData: any[] = [];
  bulkUploadErrors: string[] = [];
  isBulkUploading: boolean = false;
  allTriggerTypes: any[] = []; // Store all triggers for lookup

  searchPeriodicParam: any = {};
  searcheFilteredDataTask: any[];

  assignedusers: any[];
  isPeriodicConfigurationAvailable: boolean = false;
  configId: any;
  disabledOnclick: boolean;
  taskTriggerTypes: any[];
  private cachedPeriodicTriggerTypes$: Observable<any> | null = null;
  private cachedEventTriggerTypes$: Observable<any> | null = null;
  detailsHistory: any[];
  public ipLocalPc: any;
  approveCheck: null;
  taskRejectComment: string;
  taskParticulars: string;
  approveStatusId: any;
  saveType: any;
  isBulkDeleting: boolean = false;
  approveMultipleBtnType: any;
  isCheckerRole: any = false;
  isSearchCollapsed: boolean = true;
  isSearchCollapsedPeriodic: boolean = true;

  constructor(private cdRef: ChangeDetectorRef, private taskService: TaskService, private loaderService: LoaderService, private groupMasterService: GroupMasterService, private processService: ProcessMasterService,
    private router: Router, private commonFunction: CommonFunction, private alert: AlertComponent, private sharerService: SharerService, private route: ActivatedRoute) {
    this.currentURL = window.location.href;
    this.togglecount = 0;
    this.response = false;
    this.searchParamEvent =
    {
      // "SearchtaskUserdefinedorPredefinedModel": null,
      "SearchtaskUserdefinedorPredefinedModelPeriodicTask": null,
      "SearchtaskUserdefinedorPredefinedModelEventTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null,
      "triggerId": null
    }
    this.searchParam =
    {
      // "SearchtaskUserdefinedorPredefinedModel": null,
      "SearchtaskUserdefinedorPredefinedModelPeriodicTask": null,
      "SearchtaskUserdefinedorPredefinedModelEventTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null,
      "triggerId": null
    }

    this.searchPeriodicParam = {
      "SearchtaskUserdefinedorPredefinedModelPeriodicTask": null,
      "SearchtaskUserdefinedorPredefinedModelEventTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null,
      "triggerId": null
    }
  }

  //get user list
  getUserList() {
    // Cache the Observable to prevent multiple HTTP calls
    if (!this.cachedUsersList$) {
      // Use shareReplay(1) to cache the result and share it among all subscribers
      this.cachedUsersList$ = this.taskService.getUsersList().pipe(shareReplay(1));
    }
    
    this.cachedUsersList$.subscribe(userlist => {
      if (userlist.status == 0) {
        this.UserListData = userlist.result;
      }
    })
  }
  
  // Get cached users list Observable
  getCachedUsersList(): Observable<any> {
    if (!this.cachedUsersList$) {
      // Use shareReplay(1) to cache the result and share it among all subscribers
      this.cachedUsersList$ = this.taskService.getUsersList().pipe(shareReplay(1));
    }
    return this.cachedUsersList$;
  }

  createTask() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['addTask'] } }],
      { relativeTo: this.route.parent });

  }
  editReminderTask() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['tasks', 'editReminderFrequecies'] } }],
      { relativeTo: this.route.parent });
  }
  //get task assigned user
  getAssignTo(AssignedTo) {
    if (AssignedTo) {
      var assignedTo = _.filter(this.UserListData, ["_id", AssignedTo]);
      var AssignedUserName = (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : ""
      return AssignedUserName;
    } else {
      return ' ';
    }
  }

  getCompanyTaskList() {
    this.isLoading = true;
    var self = this;
    // Use cached Observable to prevent multiple HTTP calls
    let usersList = this.getCachedUsersList();
    console.log("usersList", usersList);
    this.taskService.getCompanyTaskList();
    var tasksDataperiodic = [];
    var tasksDataEvent = [];

    this.triggerTypeofEventBased = '2';
    let eventTaskList = this.taskService.getCompanyLibraryEventBasedTask(this.triggerTypeofEventBased, true);
    let periodicTaskList = this.taskService.getCompanyLibraryPeriodicBasedTask(this.triggerTypeofEventBased, true);

    const promises = [
      new Promise(resolve => Observable.forkJoin([eventTaskList, usersList])
        .subscribe((response) => {
          var libraryEventBasedTaskListdata = response[0].tasksDatalist.TasksData;
          let usersData = response[1].result;
          _.forEach(libraryEventBasedTaskListdata, function (activatedTask) {
            var assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
            _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" })
            var responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
            _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });
            tasksDataEvent.push(activatedTask);
          })
          this.response = false;
          resolve(tasksDataEvent)
        }, (error) => {
          console.error('Error loading event based tasks', error);
          this.response = false;
          resolve([]);
        })),
      new Promise(resolve => Observable.forkJoin([periodicTaskList, usersList])
        .subscribe((response) => {
          var periodicTaskListdata = response[0].tasksDatalist.TasksData;
          let usersData = response[1].result;
          _.forEach(periodicTaskListdata, function (activatedTask) {
            var assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
            _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" })
            var responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
            _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });
            tasksDataperiodic.push(activatedTask);
          })
          this.response = false;
          resolve(tasksDataperiodic)
        }, (error) => {
          console.error('Error loading periodic tasks', error);
          this.response = false;
          resolve([]);
        }))
    ];

    Promise.all(promises)
      .then(data => {
        // Destroy existing tables if they exist
        if ($.fn.DataTable.isDataTable('#PeriodicTaskDataTable')) {
          $('#PeriodicTaskDataTable').DataTable().destroy();
        }
        if ($.fn.DataTable.isDataTable('#eventLiberyTaskTable')) {
          $('#eventLiberyTaskTable').DataTable().destroy();
        }

        // Update data
        this.libraryEventBasedTaskList = tasksDataEvent;
        self.periodicTaskList = tasksDataperiodic;
        this.libraryPeriodicBasedTaskList = tasksDataperiodic;
        this.isLoading = false;

        // Reinitialize tables with data
        setTimeout(() => {
          $('#eventLiberyTaskTable').DataTable({
            ...this.dtOptionsEventBasedTask,
            dom: 'Blfrtip',
            buttons: [
              {
                extend: 'excel',
                text: '<i class="fa fa-files-o"></i> Export to Excel',
                className: 'btn btn-sm btn-warning',
                title: 'Library Event Based Task List',
                exportOptions: {
                  columns: [0, 2, 3, 4, 5, 7, 8, 9, 10],
                  format: {
                    body: function (data, row, column, node) {
                      if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                        if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                      } else { return data }
                    }
                  }
                }
              }
            ]
          });

          $('#PeriodicTaskDataTable').DataTable({
            ...this.dtOptionsforPeriodicTask,
            dom: 'Blfrtip',
            buttons: [
              {
                extend: 'excel',
                text: '<i class="fa fa-files-o"></i> Export to Excel',
                className: 'btn btn-sm btn-warning',
                title: 'Library Periodic Based Task List',
                exportOptions: {
                  columns: [0, 2, 3, 4, 5, 7, 8, 9, 10],
                  format: {
                    body: function (data, row, column, node) {
                      if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                        if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                      } else { return data }
                    }
                  }
                }
              }
            ]
          });
        }, 0);

        return data;
      })
      .catch(error => {
        console.error('Error loading company task list', error);
        this.isLoading = false;
      })
      .finally(() => {
        this.loaderService.disable();
      });
  }

  getProcessList() {
    this.processes = [];

    this.processService.getProcessList()
      .subscribe(processList => {
        if (processList.status == 0) {
          this.processes = processList.processList;
          this.processes = this.commonFunction.sortByKey(this.processes, 'ProcessName');
        }
      })
  }

  deleteTask() {
    if (this.environmentSettings.TaskMakerChecker) {
      this.taskService.unapproveTaskBeforeDelete(this.taskID).subscribe(response => {
        if (response.status == 0) {
          this.getCompanyTaskList();
          $('#confirmationEventTask').modal('toggle');
          this.alert.success('Task deleted successfully');
        } else {
          this.getCompanyTaskList();
          this.alert.error('Oops, something went wrong')
        }
      })
    } else {
      this.taskService.deletePredefinedCompanyTask(this.taskID).subscribe((data: any) => {
        if (data.status == 0) {
          $('#confirmationEventTask').modal('toggle');
          this.alert.success(data.message);
        }
        else {
          $('#confirmationEventTask').modal('toggle');
          this.alert.error(data.message);
        }

        this.getCompanyTaskList();

      });
    }
  }

  private deleteTaskById(taskId: string): Promise<{ success: boolean; message?: string }> {
    return new Promise((resolve) => {
      if (this.environmentSettings.TaskMakerChecker) {
        this.taskService.unapproveTaskBeforeDelete(taskId).subscribe(
          (response: any) => {
            if (response.status == 0) {
              resolve({ success: true });
            } else {
              resolve({ success: false, message: response.message || 'Unable to delete task.' });
            }
          },
          (error) => {
            resolve({
              success: false,
              message: error?.error?.message || error?.message || 'Unable to delete task.'
            });
          }
        );
      } else {
        this.taskService.deletePredefinedCompanyTask(taskId).subscribe(
          (data: any) => {
            if (data.status == 0) {
              resolve({ success: true });
            } else {
              resolve({ success: false, message: data.message || 'Unable to delete task.' });
            }
          },
          (error) => {
            resolve({
              success: false,
              message: error?.error?.message || error?.message || 'Unable to delete task.'
            });
          }
        );
      }
    });
  }

  private isSystemDefinedTask(task: any): boolean {
    const flag = task?.IsPredefined ?? task?.IsPreDefined ?? task?.IsSystemDefined;
    return flag === true || flag === 'true' || flag === 1 || flag === '1';
  }

  bulkDeleteSelectedTasks(taskType: 'event' | 'periodic') {
    const taskList = taskType === 'event' ? this.libraryEventBasedTaskList : this.libraryPeriodicBasedTaskList;
    const selectedTasks = taskList.filter(task => task.SelectedTask);

    if (!selectedTasks.length) {
      this.alert.error('Please select at least one task to delete.');
      return;
    }

    const hasSystemDefined = selectedTasks.some(task => this.isSystemDefinedTask(task));
    if (hasSystemDefined) {
      this.alert.error('System defined tasks cannot be deleted.');
      return;
    }

    this.isBulkDeleting = true;
    this.loaderService.enable();

    const deletionPromises = selectedTasks.map(task => {
      const taskId = task.ID || task._id;
      if (!taskId) {
        return Promise.resolve({ success: false, message: 'Task identifier is not available.' });
      }
      return this.deleteTaskById(taskId);
    });

    Promise.all(deletionPromises)
      .then((results) => {
        const failed = results.filter(result => !result.success);
        if (failed.length === 0) {
          this.alert.success('Selected tasks deleted successfully.');
        } else if (failed.length === results.length) {
          const message = failed[0].message || 'Unable to delete selected tasks.';
          this.alert.error(message);
        } else {
          const message = failed[0].message ? ` ${failed[0].message}` : '';
          this.alert.error(`${failed.length} task(s) could not be deleted.${message}`);
        }
      })
      .catch(() => {
        this.alert.error('Unable to delete selected tasks.');
      })
      .finally(() => {
        this.isBulkDeleting = false;
        this.loaderService.disable();
        this.getCompanyTaskList();
      });
  }

  getProcessListByProcessType(processType) {
    this.processes = [];
    var ispredefined = null;
    if (processType === 'Predefined') {
      ispredefined = true;
    } else if (processType === 'Userdefined') {
      ispredefined = false;
    }

    this.processService.getProcessList()
      .subscribe(processList => {
        if (processList.status == 0) {
          var processData = $(processList.processList).filter(function (i, n) { return n.IsPredefined === ispredefined });
          this.processes = this.commonFunction.sortByKey(processData, 'ProcessName');;
        }
      })
  }

  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList: any) => {
        if (groupList.status == 0) {
          //this.groupTypes = groupList.groupList;
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }


  addTaskstoProcess() {
    this.disabledOnclick = true;
    //var companyID = JSON.parse(localStorage.getItem("selectedCompanyID"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    for (let result of this.libraryEventBasedTaskList) {
      if (result.SelectedTask === true) {

        result.CompanyID = companyID;
        result.ProcessID = this.activateTasksForm.controls.ProcessID.value;
        this.selectedCompanytasks.push(result);
      }

    }

    var processTasksData = {
      processTasks: this.selectedCompanytasks
    }
    //this.taskService.updateCompanyTasks(companyTasks)

    this.taskService.addTaskstoProcess(processTasksData)
      .subscribe((result: any) => {
        this.disabledOnclick = false;
        if (result.status == 0) {

          $('#addtasktoprocessDialogEventTask').modal('toggle');
          $('#addtasktoprocessDialog').modal('toggle');
          const processId = this.activateTasksForm.controls.ProcessID.value;
          // this.router.navigate(['/processTasks/', processId]);
          //this.alert.successWithOk(result.message, '/process/tasks/' + processId);
          this.alert.successWithOk(result.message, '/process/edit/' + processId);

        }
        else {
          this.alert.error(result.message);
        }

        // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        //   dtInstance.destroy();
        // });
        $("html, body").animate({ scrollTop: 0 }, "slow");

        this.getCompanyTaskList();
        this.selectedCompanytasks = [];
        this.IsSelectedTasks = false;
        // $("#btnsaveTasktoProcess .close").click()
      });
  }


  companyTaskListBySearchFilter(searchParameters) {
    this.companytasklist = [];

    // this.taskService.getCompanyTaskListBySearchFilters(searchParameters)
    this.taskService.getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParameters, true)
      .subscribe(taskList => {
        // console.log("tasklist", taskList);
        if (taskList.status == 0) {
          // this.companytasklist = taskList.tasksDatalist.TasksData;
          this.companytasklist = taskList.data;
          this.response = false;
          this.dtTriggerforPeriodicTask.next();
        }

      })
  }


  eventBasedCount: number = 0;

  periodicBasedCount: number = 0;

  activatedTaskCount: number = 0
  deactivatedTaskCount: number = 0;

  checkselected(ev, isActiveTask) {
    $('[data-toggle="tooltip"]').tooltip();

    // console.log("checkselected", isActiveTask, ev);

    if (ev.target.checked == true && isActiveTask) {
      this.deactivatedTaskCount = this.deactivatedTaskCount + 1;

    } else if (ev.target.checked == true && !isActiveTask) {
      this.activatedTaskCount = this.activatedTaskCount + 1;
    }
    else if (ev.target.checked == false && isActiveTask) {
      this.deactivatedTaskCount = this.deactivatedTaskCount - 1;

    } else if (ev.target.checked == false && !isActiveTask) {
      this.activatedTaskCount = this.activatedTaskCount - 1;

    }

    this.updateSelectionState();
  }

  addToProcessEventTask: any;
  checkselectedEvent(ev, isActiveTask, triggerType) {

    if (ev.target.checked == true) {
      this.count = this.count + 1;
      this.IsSelectedTasks = true;
      this.addToProcessEventTask = true;
    } else {
      this.count = this.count - 1;
      if (this.count > 0) {
        this.IsSelectedTasks = true;
        this.addToProcessEventTask = true;
      } else {
        this.IsSelectedTasks = false;
        this.addToProcessEventTask = false;
      }
    }

    // this.setVisibilityOfButtons();
    this.updateSelectionState();

  }

  private updateSelectionState(): void {
    const hasEventSelection = (this.libraryEventBasedTaskList || []).some(task => task.SelectedTask);
    const hasPeriodicSelection = (this.periodicTaskList || []).some(task => task.SelectedTask);
    this.IsSelectedTasks = hasEventSelection || hasPeriodicSelection;
  }
  isEventBaseSelected: boolean = false;
  isPeriodicSelected: boolean = false;

  setVisibilityOfButtons() {
    //if active and inactive task selected
    if (this.countOfSelectedtask > 0 && this.countOfDeSelectedtask > 0) {
      this.IsSelectedTasks = false;
      this.isInactiveTask = false;
    }
    else if (this.countOfSelectedtask > 0) {
      this.IsSelectedTasks = true;
    }
    else if (this.countOfDeSelectedtask > 0) {
      this.isInactiveTask = true;
    }
    else // if both are not selected
    {
      this.IsSelectedTasks = false;
      this.isInactiveTask = false;
    }
    if (this.eventBasedCount > 0) {
      this.isEventBaseSelected = true;
    } else {
      this.isEventBaseSelected = false;
    }
    if (this.periodicBasedCount > 0) {
      this.isPeriodicSelected = true;
    } else {
      this.isPeriodicSelected = false;
    }


  }

  showTasksBySearchDataEventTask(searchParamEvent) {

    this.response = true;
    this.isSearchLoadingEvent = true;
    this.countOfDeSelectedtask = 0;
    this.countOfSelectedtask = 0;
    if (this.taskStatus == 'null') {
      this.taskStatus = "";
    }
    
    // Properly destroy DataTable - check if it exists first to avoid warnings
    if ($.fn.DataTable.isDataTable('#eventLiberyTaskTable')) {
      try {
        $('#eventLiberyTaskTable').DataTable().destroy();
      } catch (e) {
        // If destroy fails, try to clear the table
        console.warn('DataTable destroy warning (non-critical):', e);
      }
    }
    
    // Use cached Observable instead of UserListData array for forkJoin
    let usersList = this.getCachedUsersList();
    console.log("usersList", usersList);
    let eventTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterEventTask(searchParamEvent, true)
    if (this.searchParam.ApproveStatus === true) {
      eventTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterEventTask(searchParamEvent, false)
    } else if (this.searchParam.ApproveStatus === false) {
      eventTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterEventTask(searchParamEvent, false)
    } else {
      eventTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterEventTask(searchParamEvent, true)
    }
    Observable.forkJoin([eventTaskList, usersList])
      .subscribe((response) => {
        console.log('response', response)
        var libraryEventBasedTaskListdata = response[0].data;
        let usersData = response[1].result;
        var tasksDataEvent = [];
        // AssignedTo , CreatedBy 
        _.forEach(libraryEventBasedTaskListdata, function (activatedTask) {
          var assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
          _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" })
          //_.assign(activatedTask, { SelectedTask: false })
          var responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
          _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });

          tasksDataEvent.push(activatedTask);
        })
        // console.log('tasksDataEvent',tasksDataEvent)
        this.libraryEventBasedTaskList = tasksDataEvent;
        this.response = false;
        this.isSearchLoadingEvent = false;
        // Use setTimeout to ensure DOM is ready before reinitializing DataTable
        setTimeout(() => {
          // Use the correct trigger for event based tasks
          this.dtTriggerEventBasedTask.next();
        }, 100);
      }, (error) => {
        console.error('Error in search:', error);
        this.isSearchLoadingEvent = false;
        this.response = false;
      });

    // this.taskService.getCompanyLibraryTaskListBySearchFilterEventTask(searchParamEvent)
    //   .subscribe(taskList => {
    //     if (taskList.status == 0) {
    //       this.libraryEventBasedTaskList = taskList.data;
    //       this.response = false;
    //       this.dtTriggerEventBasedTask.next();
    //     }

    //   })


  }


  showTasksBySearchDataPeriodic(searchParam) {

    this.isSearchLoadingPeriodic = true;
    this.libraryPeriodicBasedTaskList = [];
    // Use cached Observable instead of UserListData array for forkJoin
    let usersList = this.getCachedUsersList();
    console.log("usersList", usersList);
    let periodicTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParam, true);
    if (this.searchPeriodicParam.ApproveStatus === true) {
      periodicTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParam, false);
    } else if (this.searchPeriodicParam.ApproveStatus === false) {
      periodicTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParam, false);
    } else {
      periodicTaskList = this.taskService.getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParam, true);
    }
    Observable.forkJoin([periodicTaskList, usersList])
      .subscribe((response) => {
        var periodicTaskListdata = response[0].data;
        let usersData = response[1].result;
        var tasksDataperiodic = [];

        // AssignedTo , CreatedBy 
        _.forEach(periodicTaskListdata, function (activatedTask) {
          var assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
          _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" })
          //_.assign(activatedTask, { SelectedTask: false })
          var responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
          _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });

          tasksDataperiodic.push(activatedTask);
        })
        // console.log('tasksDataperiodic',tasksDataperiodic)
        this.activatedTaskCount = 0;
        this.deactivatedTaskCount = 0;
        this.periodicTaskList = [];
        
        // Properly destroy DataTable - check if it exists first to avoid warnings
        if ($.fn.DataTable.isDataTable('#PeriodicTaskDataTable')) {
          try {
            $('#PeriodicTaskDataTable').DataTable().destroy();
          } catch (e) {
            // If destroy fails, try to clear the table
            console.warn('DataTable destroy warning (non-critical):', e);
          }
        }
        
        this.periodicTaskList = tasksDataperiodic;
        this.libraryPeriodicBasedTaskList = tasksDataperiodic;
        this.response = false;
        this.isSearchLoadingPeriodic = false;
        // Use setTimeout to ensure DOM is ready before reinitializing DataTable
        setTimeout(() => {
          // Use the correct trigger for periodic tasks
          this.dtTriggerforPeriodicTask.next();
        }, 100);
      }, (error) => {
        console.error('Error in search:', error);
        this.isSearchLoadingPeriodic = false;
        this.response = false;
      });

    // this.taskService.getCompanyLibraryTaskListBySearchFilterPeriodicTask(searchParam)
    //   .subscribe(taskList => {
    //     if (taskList.status == 0) {

    //       this.activatedTaskCount = 0;
    //       this.deactivatedTaskCount = 0;
    //       this.periodicTaskList = [];
    //       $("#PeriodicTaskDataTable").DataTable().destroy();
    //       this.periodicTaskList = taskList.data;
    //       this.response = false;
    //       this.dtTriggerforPeriodicTask.next();

    //     }

    //   })

  }

  //Show all task of periodic task
  showAllPeriodicTasks() {

    localStorage.setItem('false', 'false');
    // this.response = true;
    this.searchPeriodicParam = {
      "SearchtaskUserdefinedorPredefinedModelPeriodicTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null
    }
    // let usersList = this.taskService.getUsersList();
    // Use cached Observable instead of UserListData array for forkJoin
    let usersList = this.getCachedUsersList();
    console.log("usersList", usersList);
    let periodicTaskList = this.taskService.getCompanyLibraryPeriodicBasedTask(this.triggerTypeofEventBased, true);
    Observable.forkJoin([periodicTaskList, usersList])
      .subscribe((response) => {
        var periodicTaskListdata = response[0].tasksDatalist.TasksData;
        let usersData = response[1].result;
        var tasksDataperiodic = [];

        // AssignedTo , CreatedBy 
        _.forEach(periodicTaskListdata, function (activatedTask) {
          var assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
          _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" })
          //_.assign(activatedTask, { SelectedTask: false })
          var responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
          _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });

          tasksDataperiodic.push(activatedTask);
        })
        // console.log('tasksDataperiodic',tasksDataperiodic)
        this.activatedTaskCount = 0;
        this.deactivatedTaskCount = 0;
        $("#PeriodicTaskDataTable").DataTable().destroy();
        this.periodicTaskList = tasksDataperiodic;
        this.response = false;
        this.dtTriggerforPeriodicTask.next();
      });
    // this.taskService.getCompanyLibraryPeriodicBasedTask(this.triggerTypeofEventBased)
    //   .subscribe(taskList => {
    //     if (taskList.status == 0) {
    //       this.activatedTaskCount = 0;
    //       this.deactivatedTaskCount = 0;
    //       this.periodicTaskList = [];
    //       $("#PeriodicTaskDataTable").DataTable().destroy();
    //       this.periodicTaskList = taskList.tasksDatalist.TasksData;
    //       this.response = true;
    //       this.dtTriggerforPeriodicTask.next();
    //     }
    //   })
  }

  //Show all task of event task
  showAllEventTasks() {

    localStorage.setItem('searchcompanytask', 'false');
    this.searchParam = {
      "SearchtaskUserdefinedorPredefinedModelEventTask": null,
      "groupname": null,
      "SearchtaskEventbasedorPeriodicModel": null,
      "selcettaskname": null,
      "IsEmailSend": null
    }
    // Use cached Observable instead of UserListData array for forkJoin
    let usersList = this.getCachedUsersList();
    console.log("usersList", usersList);
        this.taskService.getCompanyTaskList()
    let eventTaskList = this.taskService.getCompanyLibraryEventBasedTask(this.triggerTypeofEventBased, true);
    Observable.forkJoin([eventTaskList, usersList])
      .subscribe((response) => {
        var libraryEventBasedTaskListdata = response[0].tasksDatalist.TasksData;
        let usersData = response[1].result;
        var tasksDataEvent = [];
        // AssignedTo , CreatedBy 
        _.forEach(libraryEventBasedTaskListdata, function (activatedTask) {
          var assignedTo = _.filter(usersData, ["_id", activatedTask.AssignedTo]);
          _.assign(activatedTask, { AssignedUserName: (assignedTo[0] != null || assignedTo[0] != undefined) ? (assignedTo[0].FirstName + " " + assignedTo[0].LastName) : "" })
          //_.assign(activatedTask, { SelectedTask: false })
          var responsibleuser = _.filter(usersData, ["_id", activatedTask.ResponsibleUser]);
          _.assign(activatedTask, { ResponsibleUserName: (responsibleuser[0] != null || responsibleuser[0] != undefined) ? (responsibleuser[0].FirstName + " " + responsibleuser[0].LastName) : "" });

          tasksDataEvent.push(activatedTask);
        });
        $("#eventLiberyTaskTable").DataTable().destroy();
        this.libraryEventBasedTaskList = tasksDataEvent;
        this.response = false;
        this.dtTriggerEventBasedTask.next();
      });



    // this.taskService.getCompanyLibraryEventBasedTask(this.triggerTypeofEventBased)
    //   .subscribe(taskList => {
    //     if (taskList.status == 0) {
    //       this.libraryEventBasedTaskList = [];
    //       $("#eventLiberyTaskTable").DataTable().destroy();
    //       this.libraryEventBasedTaskList = taskList.tasksDatalist.TasksData;
    //       this.response = true;
    //       this.dtTriggerEventBasedTask.next();
    //     }
    //   })
  }

  //For enable event task serch button
  searchEventEnable() {
    this.response = false;
  }

  showaddTasktoProcessDialog() {

    this.activateTasksForm.controls.ProcessID.setValidators([Validators.required]);
    this.activateTasksForm.controls.ProcessID.updateValueAndValidity();
    this.activateTasksForm.controls.TaskParticulars.clearValidators();
    this.activateTasksForm.controls.TaskParticulars.updateValueAndValidity();
    //this.taskForm.controls.TaskParticulars.updateValueAndValidity();
  }

  activateTasks() {
    // console.log('');
    this.response = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    for (let result of this.libraryEventBasedTaskList) {
      if (result.SelectedTask === true) {

        var selectedCompanytask = new companyTask
        selectedCompanytask.TaskParticulars = this.activateTasksForm.controls.TaskParticulars.value;
        selectedCompanytask.ID = result.ID;
        selectedCompanytask.TaskID = result.TaskID;
        selectedCompanytask.TaskName = result.TaskName;
        //result.ID=result.TasksData.ID;
        selectedCompanytask.CompanyID = companyID;
        selectedCompanytask.ProcessID = null;
        this.selectedCompanytasks.push(selectedCompanytask);

      }

    }

    var companyTasks = {
      activateCompanyTasks: this.selectedCompanytasks
    }
    //this.taskService.updateCompanyTasks(companyTasks)
    this.taskService.activateCompanyTasks(companyTasks)
      .subscribe(result => {

        if (result.status == 0) {
          //this.alert.success(result.message);
          this.alert.successWithOk1(result.message, () => {
            this.router.navigate(
              [{ outlets: { 'structure-outlet': ['tasks', 'activated'] } }],
              { relativeTo: this.route.parent });
          });
          this.checkAllPeriodicTask = false;
        }
        else {
          this.alert.error(result.message);
        }

      });
  }


  deselectTasksPerodicTask() {
    let isAllPeriodic = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    for (let result of this.periodicTaskList) {
      // console.log('result.SelectedTask', result.SelectedTask);
      if (result.SelectedTask === true) {
        var selectedCompanytask = new companyTask
        selectedCompanytask.ID = result.ID;
        selectedCompanytask.TaskID = result.TaskID;
        selectedCompanytask.TaskName = result.TaskName;
        selectedCompanytask.CompanyID = companyID;
        selectedCompanytask.ProcessID = null;
        selectedCompanytask.TriggerType = result.TriggerType;
        this.selectedCompanytasks.push(selectedCompanytask);
        if (this.selectedCompanytasks[0].TriggerType == '1') {
          isAllPeriodic = false;
        }
      }

    }
    if (isAllPeriodic) {
      var companyTasks = {
        deSelectCompanyTasks: this.selectedCompanytasks
      }

      this.taskService.deSelectCompanyTasks(companyTasks)
        .subscribe(result => {

          if (result.status == 0) {
            this.alert.success(result.message);
            this.isPeriodicSelected = false;

          }
          else {
            this.alert.error(result.message);
          }

          this.getCompanyTaskList();
          this.selectedCompanytasks = [];
          this.IsSelectedTasks = false;
          this.selectedAllPeriodicTask = false;
          this.isInactiveTask = false;
          this.countOfSelectedtask = 0;
          this.countOfDeSelectedtask = 0;
          this.activatedTaskCount = 0;
          this.deactivatedTaskCount = 0;
          this.checkAllPeriodicTask = false;

        });
    } else {
      this.alert.error('Please select Periodic Task Only for Deactivation.');
    }


  }

  //added on 19 May-- selected task to make active
  selectTasks() {

    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    for (let result of this.periodicTaskList) {
      if (result.SelectedTask === true) {
        var selectedCompanytask = new companyTask
        selectedCompanytask.ID = result.ID;
        selectedCompanytask.TaskID = result.TaskID;
        selectedCompanytask.TaskName = result.TaskName;
        selectedCompanytask.CompanyID = companyID;
        selectedCompanytask.ProcessID = null;
        this.selectedCompanytasks.push(selectedCompanytask);
      }
    }

    var companyTasks = {
      selectCompanyTasks: this.selectedCompanytasks
    }

    this.taskService.selectCompanyTasks(companyTasks)
      .subscribe(result => {
        if (result.status == 0) {
          this.alert.success(result.message);
        }
        else {
          this.alert.error(result.message);
        }

        this.getCompanyTaskList();
        this.selectedCompanytasks = [];
        this.IsSelectedTasks = false;
        this.selectedAllEventTask = false;
        this.selectedAllPeriodicTask = false;
        this.isInactiveTask = false;
        this.countOfSelectedtask = 0;
        this.countOfDeSelectedtask = 0;
        this.activatedTaskCount = 0;
        this.deactivatedTaskCount = 0;
      });
  }

  EditEventBasedTask(taskId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['updateTask', taskId] } }],
      { relativeTo: this.route.parent });
  }

  EditPeriodicBasedTask(taskId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['updateTask', taskId] } }],
      { relativeTo: this.route.parent });
  }


  // function to check wheather all checkbox select or not 
  toggleEditableCheckboxEvent(event) {
    if (event.target.checked) {
      this.erroMessage = true;
    } else {
      this.erroMessage = false;
      this.isEventBaseSelected = false;
      this.isPeriodicSelected = false;
      this.eventBasedCount = 0;
      this.periodicBasedCount = 0;
    }

  }

  // Select all Event task
  selectAllEventTask() {

    if (this.searcheFilteredDataEventTask) {

      for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {

        for (var j = 0; j < this.searcheFilteredDataEventTask.length; j++) {
          if (this.searcheFilteredDataEventTask[j] == this.libraryEventBasedTaskList[i].TaskID) {
            this.libraryEventBasedTaskList[i].SelectedTask = this.selectedAllEventTask;
            this.IsSelectedTasks = this.selectedAllEventTask;

            //added on 21 May -- to hide deselect button or select button
            //after checked all tasks- find out if active or inactive task exists   

            if (this.selectedAllEventTask == true) {
              if (this.libraryEventBasedTaskList[i].IsActive == true) {
                this.countOfSelectedtask = this.countOfSelectedtask + 1;
              }
              else if (this.libraryEventBasedTaskList[i].IsActive == false) {
                this.countOfDeSelectedtask = this.countOfDeSelectedtask + 1;
              }
            }
          }
        }

      }
      this.selectedAllEventTask = false;
      this.IsSelectedTasks = false;

    }
    else {
      this.selectedAllEventTask = true;
      for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
        this.libraryEventBasedTaskList[i].SelectedTask = this.selectedAllEventTask;
        this.IsSelectedTasks = this.selectedAllEventTask;
        //added on 21 May -- to hide deselect button or select button
        //after checked all tasks- find out if active or inactive task exists   
        if (this.selectedAllEventTask == true) {
          if (this.libraryEventBasedTaskList[i].IsActive == true) {
            this.countOfSelectedtask = this.countOfSelectedtask + 1;
          }
          else if (this.libraryEventBasedTaskList[i].IsActive == false) {
            this.countOfDeSelectedtask = this.countOfDeSelectedtask + 1;
          }
        }

      }


    }

    //to hide deselect button or select button
    this.setVisibilityOfButtons();

    this.updateSelectionState();
  }

  // Select all Periodic task
  selectedAllPeriodicTaskList: any;
  selectAllPeriodicTask(event) {
    if (event.target.checked == true) {
      console.log('checking for the datatable', $('#PeriodicTaskDataTable').DataTable().column(0, { search: 'applied' }).data())
      var filterValue = $('#PeriodicTaskDataTable').DataTable().column(0, { search: 'applied' }).data();
      if (_.size(filterValue)) {
        for (let index = 0; index < _.size(filterValue); index++) {
          var indexOfPeriodicTask = _.findIndex(this.periodicTaskList, function (element) { return element.TaskID == filterValue[index] });
          this.periodicTaskList[indexOfPeriodicTask].SelectedTask = true
          if (this.periodicTaskList[indexOfPeriodicTask].IsActive) {
            this.deactivatedTaskCount = this.deactivatedTaskCount + 1;
          }
          if (!this.periodicTaskList[indexOfPeriodicTask].IsActive) {
            this.activatedTaskCount = this.activatedTaskCount + 1;
          }
        }
        this.checkAllPeriodicTask = true

      } else {
        for (let index = 0; index < _.size(this.periodicTaskList); index++) {
          this.periodicTaskList[index].SelectedTask = true
          if (this.periodicTaskList[index].IsActive) {
            this.deactivatedTaskCount = this.deactivatedTaskCount + 1;
          }
          if (!this.periodicTaskList[index].IsActive) {
            this.activatedTaskCount = this.activatedTaskCount + 1;
          }
        }
        this.checkAllPeriodicTask = true
      }
      // else if(this.checkAllPeriodicTask) {

      // } else {

      // }
      // this.checkAllPeriodicTask = this.periodicTaskList.forEach(element => {
      //   // console.log(element.IsActive);
      //   if (element.IsActive) {
      //     this.deactivatedTaskCount = this.deactivatedTaskCount + 1;
      //   }
      //   if (!element.IsActive) {
      //     this.activatedTaskCount = this.activatedTaskCount + 1;
      //   }
      //   element.SelectedTask = true;
      // })

    } else {
      this.activatedTaskCount = 0;
      this.deactivatedTaskCount = 0;
      // this.checkAllPeriodicTask = false;

      this.checkAllPeriodicTask = this.periodicTaskList.forEach(element => {
        element.SelectedTask = false;
        for (var i = 0; i < this.periodicTaskList.length; i++) {
          this.periodicTaskList[i].SelectedTask = this.checkAllPeriodicTask;
        }
      })
    }

    this.updateSelectionState();

  }

  // Select all Event task
  selectcheckboxForEvent() {

    // console.log('mangesh=============', mangesh);
    // if(unchekedTask){
    //   this.addToProcessEventTask = true;
    // }else{
    //   this.addToProcessEventTask = true;
    // }
    this.selectedAllEventTask = this.libraryEventBasedTaskList.every(function (item: any) {
      return item.SelectedTask == true;
    })

  }

  checkIfAllSelectedEvent() {
    console.log('this.dtElementforEventBasedTask', this.libraryEventBasedTaskList, $('#eventLiberyTaskTable').DataTable().column(0, { search: 'applied' }).data())

    // this.dtElements.forEach(element => {
    //   console.log('every element', element)
    // })
    var filterValues = $('#eventLiberyTaskTable').DataTable().column(0, { search: 'applied' }).data()
    if (_.size(filterValues) && this.selectedAllEventTask) {
      for (let index = 0; index < _.size(filterValues); index++) {
        var indexOfEventTaskElement = _.findIndex(this.libraryEventBasedTaskList, function (element) { return element.TaskID == filterValues[index] })
        // console.log('indexOfEventTaskElement', indexOfEventTaskElement)
        this.libraryEventBasedTaskList[indexOfEventTaskElement].SelectedTask = true
      }
      this.addToProcessEventTask = true;
      this.IsSelectedTasks = true;
    } else if (this.selectedAllEventTask) {
      this.addToProcessEventTask = true;
      this.IsSelectedTasks = true;
      for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
        this.libraryEventBasedTaskList[i].SelectedTask = this.selectedAllEventTask;
      }
    } else {
      for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
        this.libraryEventBasedTaskList[i].SelectedTask = false;
      }
      this.addToProcessEventTask = false;
    }

    // this.dtElementforEventBasedTask.dtInstance.then((dtInstance: DataTables.Api) => {
    //   var filterValues = dtInstance.column(0, { search: 'applied' }).data()
    //   if (_.size(filterValues) && this.selectedAllEventTask) {
    //     for(let index = 0; index < _.size(filterValues); index++) {
    //       var indexOfEventTaskElement = _.findIndex(this.libraryEventBasedTaskList, function(element) { return element._id == filterValues[index]})
    //       this.libraryEventBasedTaskList[index].SelectedTask = true
    //     }
    //   } else if(this.selectedAllEventTask){
    // this.addToProcessEventTask = true;
    // this.IsSelectedTasks = true;
    //     for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
    //       this.libraryEventBasedTaskList[i].SelectedTask = this.selectedAllEventTask;
    //     }
    //   } else {
    //     for (var i = 0; i < this.libraryEventBasedTaskList.length; i++) {
    //       this.libraryEventBasedTaskList[i].SelectedTask = false;
    //     }
    //   }
    // })

  }


  CheckProcessType(item: any) {
    this.processType = item;
    this.getProcessListByProcessType(this.processType);
  }


  getSelectedGroupID(ev) {
    this.response = false;
    var id = ev.target.value;
    this.groupID = id;
  }

  //Created on 18May
  getSelectedTaskStatus(ev) {
    this.taskStatus = ev.target.value;
    this.response = false;
  }

  initialiseJqueryEvents() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }

  deleteConfirmationEventBasedTask(taskId) {
    this.taskID = taskId
    $('#confirmationEventTask').modal('toggle');
  }


  deleteConfirmationPeriodicBasedTask(taskId) {
    this.taskID = taskId
    $('#confirmationEventTask').modal('toggle');
  }

  deactiatedPeriodicTask: any;
  ngOnDestroy(): void {
    this.loaderService.enable();
    // Clear cached Observables to prevent memory leaks
    this.cachedUsersList$ = null;
    this.cachedPeriodicTriggerTypes$ = null;
    this.cachedEventTriggerTypes$ = null;
  }
  ngOnInit(): void {
    this.loaderService.enable();
    
    // Load all trigger types for bulk upload lookup
    this.loadAllTriggerTypes();
  
    this.dtOptionsforPeriodicTask = {
      paging: true,
      pagingType: 'full_numbers',
      pageLength: 10,
      scrollX: true,
      order: [[2, 'asc']],
      dom: 'Blfrtip',
      buttons: [
        {
          extend: 'excel',
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning',
          title: 'Library Periodic Based Task List',
          exportOptions: {
            columns: [0, 2, 3, 4, 5, 7, 8, 9, 10],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          }
        }
      ]
    };

    this.dtOptionsEventBasedTask = {
      paging: true,
      pagingType: 'full_numbers',
      pageLength: 10,
      scrollX: true,
      order: [[2, 'asc']],
      dom: 'Blfrtip',
      buttons: [
        {
          extend: 'excel',
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning',
          title: 'Library Event Based Task List',
          exportOptions: {
            columns: [0, 2, 3, 4, 5, 7, 8, 9, 10],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          }
        }
      ]
    };

    $('[data-toggle="tooltip"]').tooltip();
    this.environmentSettings = environment;
    this.deactiatedPeriodicTask = false;
    this.addToProcessEventTask = false;
    this.IsSelectedTasks = false;
    this.response = false;
    var hasEditPermission: any = false;
    this.hasPermission = this.commonFunction.validateURL('LibraryTask', '');

    // this.sharerService.getClientIp().subscribe((response) => {
    //   console.log('responseresponseresponse', JSON.parse(response['_body']))
    //   var ip = JSON.parse(response['_body']).ip;
    //   this.ipLocalPc = ip
    // });
    this.initialiseJqueryEvents();
    // this.commonFunction.removeDataTableSaveStateKey("companytaskTable");

    this.getGroupmasterList();
    this.getProcessList();
    // Initialize users list cache early to prevent multiple calls
    this.getCachedUsersList();
    this.getassignedUsersList();
    this.getPeriodicTaskConfiguration();
    this.getUserList();
    this.getTriggerTypeListByTriggerType('Event');

    // let searchflag = localStorage.getItem('false');
    let searchflag = null;

    var searchnewdata = JSON.parse(localStorage.getItem('companyinputdata'));


    if (searchflag == 'true') {
      // console.log(" inside search flag searchnewdata", searchnewdata);
      this.searchParam = searchnewdata;
      this.companyTaskListBySearchFilter(this.searchParam);
    }
    else {
      this.getCompanyTaskList();

    }

    $(".dt-toolbar").hide();




    this.dtDetailsHistory = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: false,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      // order: [[3, 'desc']],
      order: [1, 'desc'],
      // columnDefs: [{ width: '100px', targets: [1] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Task History List',
          title: 'Task History List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          },
        },
      ]

    }
    setTimeout(() => {
      $('.dataTable').DataTable().buttons().container().appendTo('.dataTables_wrapper .col-md-6:eq(0)');
    }, 1000);
    $('#eventLiberyTaskTable').on('draw.dt', function () {
      $(".dt-toolbar").show();
    });



    this.activateTasksForm = new FormGroup({
      TaskParticulars: new FormControl('', [Validators.required]),
      ProcessID: new FormControl('', []),
      IsPredefinedorUserdefined: new FormControl('', []),
      TaskStatus: new FormControl('', [])
    });

    this.taskConfigurationForm = new FormGroup({
      EmailId: new FormControl('', []),
      FirstName: new FormControl('', []),
      LastName: new FormControl('', []),
      MobileNumber: new FormControl('', []),
      UserId: new FormControl('', [Validators.required])
    });

    this.taskStatus = "";
    this.countOfDeSelectedtask = 0;
    this.countOfSelectedtask = 0;


    var self = this;
    setTimeout(function () {

      let table1 = $("#eventLiberyTaskTable").DataTable();
      let searchedDataForSelectAll = [];

      table1.on('search.dt', function () {
        self.searcheFilteredDataTask = [];
        let tableData = $("#eventLiberyTaskTable").DataTable().column(0, { search: 'applied' }).data();
        for (let i = 0; i < tableData.length; i++) {
          self.searcheFilteredDataTask.push(tableData[i])
        }
        let alreadySelectedElamant = _.filter(self.libraryEventBasedTaskList, function (element) { return element.SelectedTask == true })
        let filterEventLibraryTaskList = []
        for (let index = 0; index < tableData.length; index++) {
          let taskList = _.filter(self.libraryEventBasedTaskList, function (element) { return element.SelectedTask == true && element.TaskID == tableData[index] })
          filterEventLibraryTaskList = _.concat(filterEventLibraryTaskList, taskList)
        }

        let value = $('.dataTables_filter input').val();
        if (_.size(alreadySelectedElamant) == _.size(tableData)) {
          self.selectedAllEventTask = true;
        } else if ((_.size(filterEventLibraryTaskList) == _.size(tableData)) && _.size(tableData) != 0 && _.size(filterEventLibraryTaskList) != 0) {
          self.selectedAllEventTask = true;
        } else {
          self.selectedAllEventTask = false;
        }
      });
    }, 3000);

    setTimeout(function () {

      let table1 = $("#PeriodicTaskDataTable").DataTable();
      let searchedDataForSelectAll = [];
      self.deactivatedTaskCount = 0;
      self.activatedTaskCount = 0;
      table1.on('search.dt', function () {
        self.searcheFilteredDataTask = [];
        let tableData = $("#PeriodicTaskDataTable").DataTable().column(0, { search: 'applied' }).data();
        for (let i = 0; i < tableData.length; i++) {
          self.searcheFilteredDataTask.push(tableData[i])
        }
        let alreadySelectedElamant = _.filter(self.periodicTaskList, function (element) { return element.SelectedTask == true })
        let filterperiodicTaskList = []
        for (let index = 0; index < tableData.length; index++) {
          let taskList = _.filter(self.periodicTaskList, function (element) { return element.SelectedTask == true && element.TaskID == tableData[index] })
          filterperiodicTaskList = _.concat(filterperiodicTaskList, taskList)
        }

        for (let indexOffilterTask = 0; indexOffilterTask < _.size(filterperiodicTaskList); indexOffilterTask++) {
          if (filterperiodicTaskList[indexOffilterTask].IsActive) {
            self.deactivatedTaskCount = self.deactivatedTaskCount + 1;
          }
          if (!filterperiodicTaskList[indexOffilterTask].IsActive) {
            self.activatedTaskCount = self.activatedTaskCount + 1;
          }
        }
        /*
        if (this.periodicTaskList[indexOfPeriodicTask].IsActive) {
                    this.deactivatedTaskCount = this.deactivatedTaskCount + 1;
                  }
                  if (!this.periodicTaskList[indexOfPeriodicTask].IsActive) {
                    this.activatedTaskCount = this.activatedTaskCount + 1;
                  }
        
        
        
        
        */
        let value = $('.dataTables_filter input').val();
        if (_.size(alreadySelectedElamant) == _.size(tableData)) {
          self.checkAllPeriodicTask = true;
        } else if ((_.size(filterperiodicTaskList) == _.size(tableData)) && _.size(tableData) != 0 && _.size(filterperiodicTaskList) != 0) {
          self.checkAllPeriodicTask = true;
        } else {
          self.checkAllPeriodicTask = false;
        }
      });
    }, 3000);


  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      $('#eventLiberyTaskTable').DataTable({
        ...this.dtOptionsEventBasedTask,
        dom: 'Blfrtip',
        buttons: [
          {
            extend: 'excel',
            text: '<i class="fa fa-files-o"></i> Export to Excel',
            className: 'btn btn-sm btn-warning',
            title: 'Library Event Based Task List',
            exportOptions: {
              columns: [0, 2, 3, 4, 5, 7, 8, 9, 10],
              format: {
                body: function (data, row, column, node) {
                  if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                    if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                  } else { return data }
                }
              }
            }
          }
        ]
      });

      $('#PeriodicTaskDataTable').DataTable({
        ...this.dtOptionsforPeriodicTask,
        dom: 'Blfrtip',
        buttons: [
          {
            extend: 'excel',
            text: '<i class="fa fa-files-o"></i> Export to Excel',
            className: 'btn btn-sm btn-warning',
            title: 'Library Periodic Based Task List',
            exportOptions: {
              columns: [0, 2, 3, 4, 5, 7, 8, 9, 10],
              format: {
                body: function (data, row, column, node) {
                  if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                    if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                  } else { return data }
                }
              }
            }
          }
        ]
      });
    }, 0);
  }


  copyTaskLink(taskId: string): void {
    const taskLink = `${window.location.origin}/#/structure/(structure-outlet:tasks/activated/update/${taskId})`; console.log(`Generated link: ${taskLink}`);
    const tempInput = document.createElement('input');
    tempInput.style.position = 'absolute';
    tempInput.style.left = '-9999px';
    tempInput.value = taskLink;
    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999);

    try {
      document.execCommand('copy');
      alert('Task link copied successfully!');
    } catch (err) {
      console.error('Failed to copy task link:', err);
      alert('Failed to copy the task link. Please try again.');
    }
    document.body.removeChild(tempInput);
  }
  getlistbypromise(): Promise<any> {

    return this.taskService.getCompanyLibraryTaskList()
      .toPromise().then(res => {
        return Promise.resolve(res);

      })

  }

  onclickPeriodicTask() {
    this.getTriggerTypeListByTriggerType('Periodic')
    setTimeout(() => {
      $("#PeriodicTaskDataTable").DataTable().columns.adjust().draw();
    }, 200);
  }

  onclickEventTask() {
    this.getTriggerTypeListByTriggerType('Event');
    setTimeout(() => {
      $("#eventLiberyTaskTable").DataTable().columns.adjust().draw();
    }, 200);
  }

  periodicSerchDefindTask() {
    this.response = false;
  }

  enableSearchButton() {
    this.response = false;
  }
  isEnableButtonSearch() {
    this.response = false;
  }
  toggleSearchCollapse() {
    this.isSearchCollapsed = !this.isSearchCollapsed;
  }
  toggleSearchCollapsePeriodic() {
    this.isSearchCollapsedPeriodic = !this.isSearchCollapsedPeriodic;
  }

  /* Changes for configuration of periodic task (12-03-2019)*/
  getassignedUsersList() {
    this.assignedusers = [];

    this.getCachedUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Assigned to"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })
          } else {
            this.assignedusers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
        }
      })
  }

  selectedUserChange() {
    var self = this;
    var userId = this.taskConfigurationForm.controls.UserId.value
    _.forEach(this.assignedusers, function (user) {
      var foundResource = [user].filter(function (element) {
        return element._id == userId;
      });

      if (foundResource[0] != undefined) {
        self.taskConfigurationForm.controls.EmailId.setValue(foundResource[0].EmailId);
        self.taskConfigurationForm.controls.FirstName.setValue(foundResource[0].FirstName);
        self.taskConfigurationForm.controls.LastName.setValue(foundResource[0].LastName);
        self.taskConfigurationForm.controls.MobileNumber.setValue(foundResource[0].MobileNumber);

      }
    })
  }

  addPeriodicTaskConfiguration() {
    this.disabledOnclick = true;
    if (this.configId == '' || this.configId == undefined || this.configId == null) {
      var configAddObject = {
        AssignedUserId: this.taskConfigurationForm.controls.UserId.value,
        AssignedFirstName: this.taskConfigurationForm.controls.FirstName.value,
        AssignedLastName: this.taskConfigurationForm.controls.LastName.value,
        AssignedMobileNumber: this.taskConfigurationForm.controls.MobileNumber.value,
        AssignedEmailId: this.taskConfigurationForm.controls.EmailId.value
      }
      this.taskService.addPeriodicTaskConfiguration(configAddObject)
        .subscribe(result => {
          this.disabledOnclick = false;
          if (result.status == 0) {
            $('#configureSettingsDialog').modal('toggle');
            this.alert.success(result.message);
            this.getPeriodicTaskConfiguration();
          }
          else {
            this.alert.error(result.message);
          }
        });
    } else {
      var configUpdateObject = {
        AssignedUserId: this.taskConfigurationForm.controls.UserId.value,
        AssignedFirstName: this.taskConfigurationForm.controls.FirstName.value,
        AssignedLastName: this.taskConfigurationForm.controls.LastName.value,
        AssignedMobileNumber: this.taskConfigurationForm.controls.MobileNumber.value,
        AssignedEmailId: this.taskConfigurationForm.controls.EmailId.value
      }
      this.taskService.updatePeriodicTaskConfiguration(this.configId, configUpdateObject)
        .subscribe(result => {
          if (result.status == 0) {
            $('#configureSettingsDialog').modal('toggle');
            this.alert.success(result.message);
            this.getPeriodicTaskConfiguration();
          }
          else {
            this.alert.error(result.message);
          }
        });
    }

  }

  getPeriodicTaskConfiguration() {
    this.taskService.getPeriodicTaskConfiguration().subscribe(result => {
      if (result.data.length > 0) {
        var configData = result.data[0];
        this.isPeriodicConfigurationAvailable = false;
        this.configId = result.data[0]._id;
        this.taskConfigurationForm.controls.UserId.setValue(configData.PeriodicTaskConfiguration.AssignedUserId);
        this.taskConfigurationForm.controls.FirstName.setValue(configData.PeriodicTaskConfiguration.AssignedFirstName);
        this.taskConfigurationForm.controls.LastName.setValue(configData.PeriodicTaskConfiguration.AssignedLastName);
        this.taskConfigurationForm.controls.MobileNumber.setValue(configData.PeriodicTaskConfiguration.AssignedMobileNumber);
        this.taskConfigurationForm.controls.EmailId.setValue(configData.PeriodicTaskConfiguration.AssignedEmailId);
      }
    })
  }

  getTriggerTypeListByTriggerType(triggerType) {
    this.taskTriggerTypes = [];

    // Cache the Observable to prevent multiple HTTP calls
    let cachedObservable$: Observable<any> | null = null;
    if (triggerType === 'Periodic') {
      if (!this.cachedPeriodicTriggerTypes$) {
        this.cachedPeriodicTriggerTypes$ = this.taskService.getTriggerTypeListByTriggerType(triggerType).pipe(shareReplay(1));
      }
      cachedObservable$ = this.cachedPeriodicTriggerTypes$;
    } else if (triggerType === 'Event') {
      if (!this.cachedEventTriggerTypes$) {
        this.cachedEventTriggerTypes$ = this.taskService.getTriggerTypeListByTriggerType(triggerType).pipe(shareReplay(1));
      }
      cachedObservable$ = this.cachedEventTriggerTypes$;
    } else {
      // For other trigger types, use direct call
      cachedObservable$ = this.taskService.getTriggerTypeListByTriggerType(triggerType);
    }

    cachedObservable$.subscribe(tasktriggerList => {
      if (tasktriggerList.status == 0) {
        this.taskTriggerTypes = tasktriggerList.tasktriggerList;
      }
    })
  }

  historyDetailsById(detailsId) {

    // Use cached Observable instead of UserListData for forkJoin
    let usersList = this.getCachedUsersList();
    console.log("usersList", usersList);
    let hisList = this.taskService.getDetailsHistory(detailsId);
    let meetingTypeList = this.taskService.getMeetingTypeList();
    let groupList = this.groupMasterService.getGroupList();
    let triggerTypeList = this.taskService.getAllTriggerTypes();
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData2 = {
      companyID: companyDetails.companyID
    }

    Observable.forkJoin([hisList, usersList, meetingTypeList, groupList, triggerTypeList])
      .subscribe((response) => {
        console.log('response', response)
        var HistoryData;
        if (response[0].status == 0) {
          HistoryData = response[0].data
        } else {
          HistoryData = {};
        }
        var usersData;
        if (response[1].status == 0) {
          usersData = response[1].result;
        } else {
          usersData = {};
        }

        var meetingTypeData;
        if (response[2].status == 0) {
          meetingTypeData = response[2].meetingTypeList;
        } else {
          meetingTypeData = {};
        }

        var groupData;
        if ((response[3] as any).status === 0) {
          groupData = (response[3] as any).groupList;
        } else {
          groupData = {};
        }

        var triggerTypeData;
        if (response[4].status == 0) {
          triggerTypeData = response[4].tasktriggerList;
        } else {
          triggerTypeData = {};
        }
        console.log(usersData)

        var detailsHisData = [];


        _.forEach(HistoryData, function (History) {
          var recipientByName = []

          // if (History.d.SharerType == "nonGovevaUser") {
          //   var SharerBY = _.filter(sharerData, ["_id", History.d.SharerId]);
          //   _.assign(History, { SharerBYName: (SharerBY[0] != null || SharerBY[0] != undefined) ? SharerBY[0].Name : "" })
          // } else {
          //   var SharerBY = _.filter(usersData, ["_id", History.d.SharerId]);
          //   _.assign(History, { SharerBYName: (SharerBY[0] != null || SharerBY[0] != undefined) ? (SharerBY[0].FirstName + " " + SharerBY[0].LastName) : "" })
          // }

          var ModifiedByUser = _.filter(usersData, ["_id", History.d.ModifiedBy]);
          _.assign(History, { ModifiedBy: (ModifiedByUser[0] != null || ModifiedByUser[0] != undefined) ? (ModifiedByUser[0].FirstName + " " + ModifiedByUser[0].LastName) : "" })


          var CreatedByUser = _.filter(usersData, ["_id", History.d.CreatedBy]);
          _.assign(History, { CreatedByUserName: (CreatedByUser[0] != null || CreatedByUser[0] != undefined) ? (CreatedByUser[0].FirstName + " " + CreatedByUser[0].LastName) : "" })

          var AssignedTo = _.filter(usersData, ["_id", History.d.AssignedTo]);
          _.assign(History, { AssignedToName: (AssignedTo[0] != null || AssignedTo[0] != undefined) ? (AssignedTo[0].FirstName + " " + AssignedTo[0].LastName) : "" })

          var DefaultAssignedTo = _.filter(usersData, ["_id", History.d.DefaultAssignedTo]);
          _.assign(History, { DefaultAssignedToName: (DefaultAssignedTo[0] != null || DefaultAssignedTo[0] != undefined) ? (DefaultAssignedTo[0].FirstName + " " + DefaultAssignedTo[0].LastName) : "" })

          var ResponsibleUser = _.filter(usersData, ["_id", History.d.ResponsibleUser]);
          _.assign(History, { ResponsibleUserName: (ResponsibleUser[0] != null || ResponsibleUser[0] != undefined) ? (ResponsibleUser[0].FirstName + " " + ResponsibleUser[0].LastName) : "" })

          var Collegue = _.filter(usersData, ["_id", History.d.Collegues]);
          _.assign(History, { CollegueName: (Collegue[0] != null || Collegue[0] != undefined) ? (Collegue[0].FirstName + " " + Collegue[0].LastName) : "" })

          var Escalation1Assigned = _.filter(usersData, ["_id", History.d.Escalation1ofAssignedTo]);
          _.assign(History, { Escalation1AssignedName: (Escalation1Assigned[0] != null || Escalation1Assigned[0] != undefined) ? (Escalation1Assigned[0].FirstName + " " + Escalation1Assigned[0].LastName) : "" })

          var Escalation2Assigned = _.filter(usersData, ["_id", History.d.Escalation2ofAssignedTo]);
          _.assign(History, { Escalation2AssignedName: (Escalation2Assigned[0] != null || Escalation2Assigned[0] != undefined) ? (Escalation2Assigned[0].FirstName + " " + Escalation2Assigned[0].LastName) : "" })

          var Escalation1Responsible = _.filter(usersData, ["_id", History.d.Escalation1ofResponsibleUser]);
          _.assign(History, { Escalation1ResponsibleName: (Escalation1Responsible[0] != null || Escalation1Responsible[0] != undefined) ? (Escalation1Responsible[0].FirstName + " " + Escalation1Responsible[0].LastName) : "" })

          var Escalation2Responsible = _.filter(usersData, ["_id", History.d.Escalation2ofResponsibleUser]);
          _.assign(History, { Escalation2ResponsibleName: (Escalation2Responsible[0] != null || Escalation2Responsible[0] != undefined) ? (Escalation2Responsible[0].FirstName + " " + Escalation2Responsible[0].LastName) : "" })

          var groupName = _.filter(groupData, ["_id", History.d.GroupID]);
          _.assign(History, { groupName: (groupName[0] != null || groupName[0] != undefined) ? groupName[0].GroupName : "" })

          var meetingTypeName = _.filter(meetingTypeData, ["_id", History.d.MeetingTypeID]);
          _.assign(History, { meetingTypeName: (meetingTypeName[0] != null || meetingTypeName[0] != undefined) ? meetingTypeName[0].MeetingType : "" })

          var triggerTypeName = _.filter(triggerTypeData, ["_id", History.d.TriggerID]);
          _.assign(History, { triggerTypeName: (triggerTypeName[0] != null || triggerTypeName[0] != undefined) ? triggerTypeName[0].Name : "" })

          // var NatureofUPSIItem  =   _.filter(NatureofUPSIList,["_id",History.d.NatureofUPSI])
          // _.assign(History, { NatureofUPSI:(NatureofUPSIItem[0] != null || NatureofUPSIItem[0] != undefined)?NatureofUPSIItem[0].Item:""})

          // _.forEach(History.d.Recipients, function (RecipientsId) {

          //   console.log('RecipientsId',RecipientsId.Name)
          //   recipientByName.push((RecipientsId.Name) ?RecipientsId.Name: (RecipientsId.FirstName + " " + RecipientsId.LastName))

          //   // if (History.d.RecipientType == "nonGovevaUser") {
          //   //   var recipientName = _.filter(recipientData, ["_id", RecipientsId])
          //   //   recipientByName.push((recipientName[0] != null || recipientName[0] != undefined) ? recipientName[0].Name : "")
          //   // } else {

          //   //   var recipientName = _.filter(usersData, ["_id", RecipientsId])
          //   //   recipientByName.push((recipientName[0] != null || recipientName[0] != undefined) ? (recipientName[0].FirstName + " " + recipientName[0].LastName) : "")

          //   // }
          // })
          // _.assign(History, { recipientByName })

          detailsHisData.push(History);
        })

        console.log(detailsHisData)


        // detailsHisData = detailsHisData.filter(function (x) {
        //   return (x.d.IPAddress != '' && x.d.IPAddress != null)

        // })

        // detailsHisData = detailsHisData.filter(function (x) {
        //   return (_.size(x.d.Recipients) > 0)

        // })




        $("#Historytable").DataTable().destroy();
        this.detailsHistory = []
        this.detailsHistory = detailsHisData;
        console.log(this.detailsHistory)

        this.dtDetailsTrigger.next();
        $('#historyModel').modal('show');
      });




  }

  approveMultipleTasksConfirmation(type) {
    this.approveCheck = null;
    this.taskRejectComment = "";
    this.taskParticulars = "";
    this.approveBtnType = 'multi';
    this.approveMultipleBtnType = type;
    $('#approveTaskStatusDialog').modal('toggle');
  }

  approveTaskStatusConfirmation(taskId, type) {
    this.approveCheck = null;
    this.taskRejectComment = "";
    this.taskParticulars = "";
    if (type == 'delete') {
      this.deleteConfirmationEventBasedTask(taskId)
    } else {
      this.approveStatusId = taskId;
      this.approveBtnType = 'single';
      this.saveType = type;
      $('#approveTaskStatusDialog').modal('toggle');
    }
  }

  approveTask() {
    if (this.approveCheck == true && (this.taskParticulars == "" || this.taskParticulars == null || this.taskParticulars == undefined)) {
      this.alert.error('Task Particulars field is required');
    } else {
      var object = {
        taskId: this.approveStatusId,
        approveCheck: this.approveCheck,
        taskRejectComment: this.taskRejectComment,
        IPAddress: this.ipLocalPc,
        isRejected: (this.approveCheck == false || this.approveCheck == 'false') ? true : false,
        saveType: this.saveType,
        taskParticulars: this.taskParticulars
      }
      this.taskService.approveTask(object)
        .subscribe(response => {
          if (response.status == 0) {
            this.showAllPeriodicTasks();
            this.showAllEventTasks();
            $('#approveTaskStatusDialog').modal('toggle');
            if (this.approveCheck == 'true' || this.approveCheck == true) {
              this.alert.success('Task approved successfully')
            } else {
              this.alert.success('Task rejected successfully')
            }
          }
        })
    }
  }

  approveMultipleTasks() {
    // this.response = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;
    this.selectedCompanytasks = [];
    if (this.approveMultipleBtnType == 'event') {
      for (let result of this.libraryEventBasedTaskList) {
        if (result.SelectedTask === true) {
          this.selectedCompanytasks.push(result);
        }

      }
    } else if (this.approveMultipleBtnType == 'periodic') {
      for (let result of this.periodicTaskList) {
        // console.log('result.SelectedTask', result.SelectedTask);
        if (result.SelectedTask === true) {
          this.selectedCompanytasks.push(result);
        }
      }
    }


    var object = {
      taskDetails: this.selectedCompanytasks,
      approveCheck: this.approveCheck,
      taskRejectComment: this.taskRejectComment,
      IPAddress: this.ipLocalPc,
      isRejected: (this.approveCheck == false || this.approveCheck == 'false') ? true : false,
      // saveType: this.saveType
    }
    //this.taskService.updateCompanyTasks(companyTasks)
    this.taskService.approveMultipleTask(object)
      .subscribe(result => {

        if (result.status == 0) {
          this.showAllPeriodicTasks();
          this.showAllEventTasks();
          $('#approveTaskStatusDialog').modal('toggle');
          if (this.approveCheck == 'true' || this.approveCheck == true) {
            this.alert.success('Tasks approved successfully')
          } else {
            this.alert.success('Tasks rejected successfully')
          }

        }

      });
  }

  // Load all trigger types for bulk upload
  loadAllTriggerTypes() {
    this.allTriggerTypes = [];
    
    // Use cached Observables to prevent duplicate calls
    // Initialize Event trigger cache if not already done
    if (!this.cachedEventTriggerTypes$) {
      this.cachedEventTriggerTypes$ = this.taskService.getTriggerTypeListByTriggerType('Event').pipe(shareReplay(1));
    }
    // Initialize Periodic trigger cache if not already done
    if (!this.cachedPeriodicTriggerTypes$) {
      this.cachedPeriodicTriggerTypes$ = this.taskService.getTriggerTypeListByTriggerType('Periodic').pipe(shareReplay(1));
    }
    
    // Load event-based triggers using cached Observable
    this.cachedEventTriggerTypes$.subscribe((result) => {
      if (result.status == 0) {
        const eventTriggers = result.tasktriggerList.map(t => ({ ...t, TriggerType: 'Event' }));
        this.allTriggerTypes.push(...eventTriggers);
      }
    });

    // Load periodic triggers using cached Observable
    this.cachedPeriodicTriggerTypes$.subscribe((result) => {
      if (result.status == 0) {
        const periodicTriggers = result.tasktriggerList.map(t => ({ ...t, TriggerType: 'Periodic' }));
        this.allTriggerTypes.push(...periodicTriggers);
      }
    });
  }

  // Find trigger ID by name and type
  getTriggerIdByName(triggerName: string, triggerType: string): string | null {
    if (!triggerName || !triggerType) {
      return null;
    }
    const normalizedName = triggerName.toString().trim().toLowerCase();
    const normalizedType = triggerType.toString().trim().toLowerCase();
    const trigger = this.allTriggerTypes.find(t => {
      const currentName = t.Name ? t.Name.toString().trim().toLowerCase() : '';
      const currentType = t.TriggerType ? t.TriggerType.toString().trim().toLowerCase() : '';
      return currentName === normalizedName && currentType === normalizedType;
    });
    return trigger?._id || null;
  }

  // Bulk Upload Methods
  downloadBulkUploadTemplate() {
    const workbook = XLSX.utils.book_new();

    // Create worksheet with headers only (no sample data)
    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        'Task Name*',
        'Task Description*',
        'Tag*',
        'Global/Company*',
        'Emails',
        'Statutory/Internal',
        'Risk Profile',
        'System Defined Consequences',
        'User Defined Consequences',
        'Meeting Type',
        'Trigger Type*',
        'Trigger Name*',
        'Reminder Days',
        'Completion Days',
        'Email Contents',
        'Assigned To',
        'Escalation 1',
        'Escalation 2',
        'Responsible User',
        'Colleagues CC'
      ]
    ]);

    // Set column widths
    const wscols = [
      { wch: 25 }, // Task Name
      { wch: 30 }, // Task Description
      { wch: 20 }, // Tag
      { wch: 15 }, // Global/Company
      { wch: 10 }, // Emails
      { wch: 18 }, // Statutory/Internal
      { wch: 15 }, // Risk Profile
      { wch: 30 }, // System Consequences
      { wch: 30 }, // User Consequences
      { wch: 20 }, // Meeting Type
      { wch: 15 }, // Trigger Type
      { wch: 20 }, // Trigger ID
      { wch: 15 }, // Reminder Days
      { wch: 15 }, // Completion Days
      { wch: 30 }, // Email Contents
      { wch: 30 }, // Assigned To
      { wch: 30 }, // Escalation 1
      { wch: 30 }, // Escalation 2
      { wch: 20 }, // Responsible User
      { wch: 30 }  // Colleagues CC
    ];
    worksheet['!cols'] = wscols;

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Task Template');

    // Add instructions sheet
    const instructions = [
      { 'Field': 'Task Name*', 'Description': 'Required. Name of the task', 'Example': 'Prepare Financial Report' },
      { 'Field': 'Task Description*', 'Description': 'Required. Detailed description', 'Example': 'Prepare quarterly financial report' },
      { 'Field': 'Tag*', 'Description': 'Required. Exact tag name from system', 'Example': 'Finance' },
      { 'Field': 'Global/Company*', 'Description': 'Required. Type "Global" or "Company" exactly', 'Example': 'Company' },
      { 'Field': 'Emails', 'Description': 'Type "TRUE" or "FALSE"', 'Example': 'TRUE' },
      { 'Field': 'Statutory/Internal', 'Description': 'Type "1" for Statutory or "2" for Internal', 'Example': '1' },
      { 'Field': 'Risk Profile', 'Description': 'Type 1=High, 2=Medium, 3=Low', 'Example': '2' },
      { 'Field': 'Meeting Type', 'Description': 'Optional. Exact meeting type name', 'Example': 'Board Meeting' },
      { 'Field': 'Trigger Type*', 'Description': 'Required. Type "Event" or "Periodic" exactly', 'Example': 'Event' },
      { 'Field': 'Trigger Name*', 'Description': 'Required. Exact trigger name from system (not ID)', 'Example': 'Board Meeting Conducted' },
      { 'Field': 'Reminder Days', 'Description': 'Number of days before task to send reminder', 'Example': '7' },
      { 'Field': 'Completion Days', 'Description': 'Number of days to complete the task', 'Example': '30' },
      { 'Field': 'System Defined Consequences', 'Description': 'If filled, task is treated as system-defined (predefined). Users cannot edit user-defined field.', 'Example': 'Penalty of ₹100 per day for delay' },
      { 'Field': 'User Defined Consequences', 'Description': 'If provided (and system-defined left empty), task is treated as user-defined.', 'Example': 'Provide compliance update to CFO' },
      { 'Field': 'Email Contents', 'Description': 'Optional. Custom email template content', 'Example': 'Please complete this task' },
      { 'Field': 'IMPORTANT', 'Description': 'Use exact names from system. System will lookup IDs automatically.', 'Example': '' },
      { 'Field': 'Note', 'Description': 'Fields marked with * are mandatory. Ensure all spellings match exactly.', 'Example': '' }
    ];

    const instructionsSheet = XLSX.utils.json_to_sheet(instructions);
    instructionsSheet['!cols'] = [{ wch: 25 }, { wch: 50 }, { wch: 40 }];
    XLSX.utils.book_append_sheet(workbook, instructionsSheet, 'Instructions');

    // Generate file name
    const date = new Date();
    const fileName = `Task_Bulk_Upload_Template_${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}.xlsx`;

    // Save the file
    XLSX.writeFile(workbook, fileName);
    console.log('Template downloaded successfully!');
  }

  onBulkUploadFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedBulkFile = file;
      this.parseBulkUploadFile(file);
    }
  }

  parseBulkUploadFile(file: File) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        
        // Get the first sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        // Convert to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });
        
        if (jsonData.length === 0) {
          this.bulkUploadErrors = ['The uploaded file is empty or has no data.'];
          console.error('Empty file uploaded');
          return;
        }

        // Validate and prepare data
        this.validateAndPrepareBulkData(jsonData);
        
      } catch (error) {
        console.error('Error parsing file:', error);
        this.bulkUploadErrors = ['Error reading the Excel file. Please ensure it is a valid Excel file.'];
        this.bulkUploadPreviewData = [];
      }
    };
    reader.readAsArrayBuffer(file);
  }

  validateAndPrepareBulkData(data: any[]) {
    this.bulkUploadPreviewData = [];
    this.bulkUploadErrors = [];
    
    // Skip empty rows (sample data row)
    const filteredData = data.filter(row => {
      const taskName = row['Task Name*'];
      return taskName && taskName !== 'Sample Task Name' && taskName.trim() !== '';
    });

    if (filteredData.length === 0) {
      this.bulkUploadErrors = ['No valid data rows found in the uploaded file. Please add at least one task.'];
      console.log('No valid data rows found');
      return;
    }
    
    filteredData.forEach((row, index) => {
      const rowNumber = index + 2; // +2 because Excel starts at 1 and we have a header row
      let hasError = false;
      const errors: string[] = [];
      const triggerTypeValue = row['Trigger Type*'] ? row['Trigger Type*'].toString().trim() : '';
      const triggerNameValue = row['Trigger Name*'] ? row['Trigger Name*'].toString().trim() : '';
      const preConsequencesValue = row['System Defined Consequences'] ? row['System Defined Consequences'].toString().trim() : '';
      const userConsequencesValue = row['User Defined Consequences'] ? row['User Defined Consequences'].toString().trim() : '';

      // Required field validations
      if (!row['Task Name*'] || row['Task Name*'].trim() === '') {
        errors.push(`Row ${rowNumber}: Task Name is required`);
        hasError = true;
      }

      if (!row['Task Description*'] || row['Task Description*'].trim() === '') {
        errors.push(`Row ${rowNumber}: Task Description is required`);
        hasError = true;
      }

      if (!row['Tag*'] || row['Tag*'].trim() === '') {
        errors.push(`Row ${rowNumber}: Tag is required`);
        hasError = true;
      }

      if (!row['Global/Company*'] || !['Global', 'Company'].includes(row['Global/Company*'])) {
        errors.push(`Row ${rowNumber}: Global/Company must be either "Global" or "Company"`);
        hasError = true;
      }

      if (!triggerTypeValue || !['Event', 'Periodic'].includes(triggerTypeValue)) {
        errors.push(`Row ${rowNumber}: Trigger Type must be either "Event" or "Periodic"`);
        hasError = true;
      }

      if (!triggerNameValue) {
        errors.push(`Row ${rowNumber}: Trigger Name is required`);
        hasError = true;
      }
      
      // Validate that trigger name exists in system
      if (triggerNameValue && triggerTypeValue) {
        const triggerId = this.getTriggerIdByName(triggerNameValue, triggerTypeValue);
        if (!triggerId) {
          errors.push(`Row ${rowNumber}: Trigger "${triggerNameValue}" not found for type "${triggerTypeValue}"`);
          hasError = true;
        }
      }

      if (preConsequencesValue && userConsequencesValue) {
        errors.push(`Row ${rowNumber}: Provide either System Defined or User Defined Consequences, not both.`);
        hasError = true;
      }

      // Prepare task object
      const taskData = {
        TaskName: row['Task Name*'],
        TaskDescription: row['Task Description*'],
        Tag: row['Tag*'],
        IsGlobal: row['Global/Company*'],
        Email: row['Emails'] === 'TRUE' || row['Emails'] === true,
        PolicyType: row['Statutory/Internal'],
        RiskProfile: row['Risk Profile'],
        PreConsequences: preConsequencesValue,
        UserConsequences: userConsequencesValue,
        MeetingType: row['Meeting Type'],
        TriggerType: triggerTypeValue,
        TriggerName: triggerNameValue,
        ReminderDays: row['Reminder Days'],
        CompletionDays: row['Completion Days'],
        EmailContents: row['Email Contents'],
        AssignedTo: row['Assigned To'],
        Escalation1: row['Escalation 1'],
        Escalation2: row['Escalation 2'],
        ResponsibleUser: row['Responsible User'],
        ColleaguesCC: row['Colleagues CC'],
        hasError: hasError,
        rowNumber: rowNumber
      };

      this.bulkUploadPreviewData.push(taskData);
      this.bulkUploadErrors.push(...errors);
    });

    // Log results instead of showing alerts
    if (this.bulkUploadErrors.length === 0) {
      console.log(`✓ ${this.bulkUploadPreviewData.length} tasks validated successfully!`);
    } else {
      console.log(`⚠ Validation found ${this.bulkUploadErrors.length} error(s)`);
    }
  }

  processBulkUpload() {
    if (this.bulkUploadErrors.length > 0) {
      console.error('Cannot upload: Validation errors exist');
      return;
    }

    if (this.bulkUploadPreviewData.length === 0) {
      console.error('Cannot upload: No tasks to upload');
      return;
    }

    this.isBulkUploading = true;

    // Process each task
    const taskPromises = this.bulkUploadPreviewData.map(taskData => {
      // Here you would call your existing task creation API
      // For now, this is a placeholder
      return this.createSingleTaskFromBulk(taskData);
    });

    Promise.all(taskPromises)
      .then(results => {
        const successCount = results.filter(r => r.success).length;
        const failCount = results.length - successCount;
        const errors = results.filter(r => !r.success).map(r => r.error).filter(e => e);
        
        console.log(`Upload complete: ${successCount} success, ${failCount} failed`);
        if (errors.length > 0) {
          console.error('Upload errors:', errors);
        }
        
        // Manually close modal without fade animation - remove backdrop first
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        
        const modal = document.getElementById('bulkUploadModal');
        if (modal) {
          modal.style.display = 'none';
          modal.classList.remove('show');
          modal.setAttribute('aria-hidden', 'true');
        }
        
        document.body.classList.remove('modal-open');
        document.body.style.paddingRight = '';
        
        this.resetBulkUpload();
        
        // Refresh task list first
        this.getCompanyTaskList();
        
        // Show single success/error message after everything is cleaned up
        setTimeout(() => {
          if (failCount === 0) {
            this.alert.success(`Successfully created ${successCount} task${successCount > 1 ? 's' : ''}!`);
          } else {
            const errorMsg = errors.length > 0 ? ` Errors: ${errors.slice(0, 3).join(', ')}${errors.length > 3 ? '...' : ''}` : '';
            this.alert.error(`Created ${successCount} task${successCount > 1 ? 's' : ''}. ${failCount} task${failCount > 1 ? 's' : ''} failed.${errorMsg}`);
          }
        }, 500);
      })
      .catch(error => {
        console.error('Bulk upload error:', error);
        this.isBulkUploading = false;
        
        // Manually close modal
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
        
        const modal = document.getElementById('bulkUploadModal');
        if (modal) {
          modal.style.display = 'none';
          modal.classList.remove('show');
          modal.setAttribute('aria-hidden', 'true');
        }
        
        document.body.classList.remove('modal-open');
        document.body.style.paddingRight = '';
        
        // Show single error message after cleanup
        setTimeout(() => {
          this.alert.error('An error occurred during bulk upload. Please try again.');
        }, 500);
      })
      .finally(() => {
        this.isBulkUploading = false;
      });
  }

  createSingleTaskFromBulk(taskData: any): Promise<{ success: boolean, error?: string }> {
    return new Promise((resolve) => {
      try {
        // Get company details
        const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));
        const companyID = companyDetails?.companyID;
        
        // Find Group ID from Tag name
        const group = this.groupTypes?.find(g => g.GroupName === taskData.Tag);
        if (!group) {
          resolve({ success: false, error: `Tag "${taskData.Tag}" not found` });
          return;
        }
        
        // Find Trigger ID by name
        const triggerId = this.getTriggerIdByName(taskData.TriggerName, taskData.TriggerType);
        if (!triggerId) {
          resolve({ success: false, error: `Trigger "${taskData.TriggerName}" not found for type "${taskData.TriggerType}"` });
          return;
        }
        
        // Determine IsGlobal
        const isGlobal = taskData.IsGlobal === 'Global';
        const companyId = isGlobal ? null : companyID;
        
        const rawPreConsequences = (taskData.PreConsequences ?? '').toString().trim();
        const rawUserConsequences = (taskData.UserConsequences ?? '').toString().trim();
        const isSystemDefined = rawPreConsequences.length > 0;
        const preConsequences = isSystemDefined ? rawPreConsequences : '';
        const userConsequences = isSystemDefined ? '' : rawUserConsequences;

        // Determine TriggerType
        let triggerType = null;
        if (taskData.TriggerType === 'Event') {
          triggerType = 1;
        } else if (taskData.TriggerType === 'Periodic') {
          triggerType = 2;
        }
        
        // Build task object matching the API format exactly (based on Joi schema)
        const newTask = {
          TaskName: taskData.TaskName?.trim() || '',
          TaskDescription: taskData.TaskDescription?.trim() || '',
          GroupID: group._id,
          IsGlobal: isGlobal,
          MeetingTypeID: taskData.MeetingType ? this.getMeetingTypeId(taskData.MeetingType) : null,
          ReminderDays: taskData.ReminderDays ? parseInt(taskData.ReminderDays) : null,
          ReminderPeriod: null, // Reminder frequency
          EscalationDays: null, // First escalation days
          Level2EscalationDays: null, // Second escalation days
          CompletionDays: taskData.CompletionDays ? parseInt(taskData.CompletionDays) : null,
          TriggerType: triggerType,
          TriggerID: triggerId, // Looked up from trigger name
          DateOption: 1, // Required, default to 1
          EmailSendForTask: taskData.Email || false,
          ReminderPeriodLevel1: null, // Level 1 reminder frequency
          ReminderPeriodLevel2: null, // Level 2 reminder frequency
          EmailContents: taskData.EmailContents || '',
          PolicyType: taskData.PolicyType ? parseInt(taskData.PolicyType) : 0,
          RiskType: taskData.RiskProfile ? parseInt(taskData.RiskProfile) : 0,
          PreConsequences: preConsequences,
          UserConsequences: userConsequences,
          AssignedTo: [], // Array - can be empty
          ResponsibleUser: [], // Array - can be empty
          IsActive: true,
          IsPredefined: isSystemDefined,
          Escalation1ofAssignedTo: [], // Array - can be empty
          Escalation2ofAssignedTo: [], // Array - can be empty
          Escalation1ofResponsibleUser: [], // Array - can be empty
          Escalation2ofResponsibleUser: [], // Array - can be empty
          Collegues: [], // Array - can be empty
          TriggerStartDate: null,
          EndDate: null,
          ProcessID: null,
          DefaultAssignedTo: null,
          FixedDate: null,
          isApproved: !environment.TaskMakerChecker,
          IPAddress: null,
          type: 'add',
          DocumentFile: null
        };
        
        // Log what we're sending
        console.log('Creating task from bulk upload:', {
          TaskName: newTask.TaskName,
          TriggerType: triggerType === 1 ? 'Event' : 'Periodic',
          TriggerName: taskData.TriggerName,
          TriggerID: triggerId,
          GroupID: newTask.GroupID,
          Tag: taskData.Tag
        });
        
        // Call the actual API
        this.taskService.addTask(newTask).subscribe(
          (response) => {
            console.log('Task creation response:', response);
            if (response.status == 0) {
              resolve({ success: true });
            } else {
              const errorMsg = response.message || response.err_fields || 'Failed to create task';
              console.error('Task creation failed:', errorMsg);
              resolve({ success: false, error: `${taskData.TaskName}: ${errorMsg}` });
            }
          },
          (error) => {
            console.error('Error creating task:', taskData.TaskName, error);
            const errorMsg = error.error?.message || error.message || 'API Error';
            resolve({ success: false, error: `${taskData.TaskName}: ${errorMsg}` });
          }
        );
      } catch (error) {
        console.error('Error preparing task:', error);
        resolve({ success: false, error: error.message || 'Error preparing task' });
      }
    });
  }

  getMeetingTypeId(meetingTypeName: string): string | null {
    if (!meetingTypeName) {
      return null;
    }
    const trimmedName = meetingTypeName.toString().trim();
    const meetingType = this.meetingTypes?.find(m => m.MeetingType && m.MeetingType.toString().trim() === trimmedName);
    return meetingType?._id || null;
  }

  getUserIdFromEmail(email: string): string | null {
    // This would need to lookup user by email
    // For now, returning null - you may need to implement user lookup
    return null;
  }

  getUserIdsFromEmails(emailsString: string): string[] | null {
    if (!emailsString) return null;
    // Split by comma and get user IDs
    // This would need actual user lookup by email
    // For now, returning empty array
    return [];
  }

  resetBulkUpload() {
    // Manually close modal without fade
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
    
    const modal = document.getElementById('bulkUploadModal');
    if (modal) {
      modal.style.display = 'none';
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
    }
    
    document.body.classList.remove('modal-open');
    document.body.style.paddingRight = '';
    
    // Reset state
    this.selectedBulkFile = null;
    this.bulkUploadPreviewData = [];
    this.bulkUploadErrors = [];
    this.isBulkUploading = false;
    
    // Reset file input
    const fileInput = document.getElementById('bulkUploadFile') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
}